module.exports = __webpack_public_path__ + "fonts/iconfont.8362be32.woff";